import resolve from 'ioc/resolve'
import basicController from 'servicestack/basic.controller.properties'


class ProductTemplateManagerDependentController  {
    constructor() {
        basicController(this)
        const $ctrl = this;
    }
    $onInit() {
        const $ctrl = this;
        $ctrl.query = $ctrl.manager.query;
        $ctrl.navs = $ctrl.manager.navs;
    }
}

export default ProductTemplateManagerDependentController;
